function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _BaseError;
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import uuidv4 from 'uuid/v4';
export var BaseError = /*#__PURE__*/function (_Error) {
  function BaseError() {
    var _this;
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      message = _ref.message,
      data = _ref.data,
      cause = _ref.cause;
    _classCallCheck(this, BaseError);
    _this = _callSuper(this, BaseError, [message]);
    _defineProperty(_this, "data", {});
    _defineProperty(_this, "name", 'BaseError');
    _defineProperty(_this, "errorId", uuidv4());
    if (typeof data !== 'undefined') {
      _this.data = data;
    }
    if (Error.captureStackTrace) {
      Error.captureStackTrace(_this, _this.constructor);
    }
    if (cause) {
      _this.cause = cause;
      _this.stack = "".concat(_this.stack, "\nCaused by: ").concat(cause.stack || cause.toString());
    }
    return _this;
  }
  _inherits(BaseError, _Error);
  return _createClass(BaseError, [{
    key: "code",
    get: function get() {
      var codeContainer = [];
      var codeSeparator = '.';
      var prototypeValue = Reflect.getPrototypeOf(this);
      if (prototypeValue === BaseError.prototype) {
        return BaseError.errorCode;
      }
      while (prototypeValue !== BaseError.prototype && prototypeValue !== null) {
        codeContainer.push(prototypeValue.constructor.errorCode);
        prototypeValue = Reflect.getPrototypeOf(prototypeValue);
      }
      return codeContainer.reverse().join(codeSeparator);
    }
  }], [{
    key: "extend",
    value: function extend(name) {
      var child = _defineProperty({}, name, /*#__PURE__*/function (_this2) {
        function _class() {
          var _this3;
          _classCallCheck(this, _class);
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          _this3 = _callSuper(this, _class, [].concat(args));
          _defineProperty(_this3, "name", name);
          return _this3;
        }
        _inherits(_class, _this2);
        return _createClass(_class);
      }(this));
      child[name].setErrorCode(_classNameToErrorCode.call(BaseError, name));
      return child[name];
    }
  }, {
    key: "setErrorCode",
    value: function setErrorCode(errorCode) {
      this.errorCode = errorCode;
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(Error));
_BaseError = BaseError;
function _classNameToErrorCode(toLowerCase) {
  var errorCode = toLowerCase.charAt(0).toLowerCase() + toLowerCase.slice(1);
  if (errorCode.endsWith(_assertClassBrand(_BaseError, this, _codePattern)._)) {
    errorCode = errorCode.slice(0, -Math.abs(_assertClassBrand(_BaseError, this, _codePattern)._.length));
  }
  return errorCode;
}
_defineProperty(BaseError, "errorCode", 'base');
var _codePattern = {
  _: 'Error'
};